/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { OperationToJSON, UserIncidentImageFromJSON, UserIncidentImageToJSON, UserIncidentImageEntityCursorPageResponseFromJSON, ViewIncidentFileResponseFromJSON, } from '../models/index';
/**
 *
 */
export class AdminIncidentImagesApi extends runtime.BaseAPI {
    /**
     */
    adminIncidentImagesCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserIncidentImageToJSON(requestParameters.userIncidentImage),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentImagesCreate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentImagesCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentImagesDeleteByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentImagesDeleteById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    adminIncidentImagesDeleteById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminIncidentImagesDeleteByIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    adminIncidentImagesGetByIdByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentImagesGetByIdById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentImagesGetByIdById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentImagesGetByIdByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentImagesGetForDownloadByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentImagesGetForDownloadById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ViewIncidentFileResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentImagesGetForDownloadById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentImagesGetForDownloadByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentImagesPaginateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.search !== undefined) {
                queryParameters['search'] = requestParameters.search;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.filters !== undefined) {
                queryParameters['filters'] = requestParameters.filters;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageEntityCursorPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentImagesPaginate(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentImagesPaginateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    adminIncidentImagesUpdateByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling adminIncidentImagesUpdateById.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/admin/incident-images/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.operation.map(OperationToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentImageFromJSON(jsonValue));
        });
    }
    /**
     */
    adminIncidentImagesUpdateById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.adminIncidentImagesUpdateByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
